<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>people</mat-icon></div>
          <mat-card-title>
            Clientes
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario">
            <div class="row">
              <div class="col-12 col-md-1">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>ID</mat-label>
                  <input formControlName="id" matInput readonly>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>CNPJ</mat-label>
                  <input formControlName="documento" matInput mask="00.000.000/0000-00">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Nome Fantasia</mat-label>
                  <input formControlName="nomeFantasia" matInput minlength="3" maxlength="250" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Razão Social</mat-label>
                  <input formControlName="razaoSocial" matInput minlength="3" maxlength="250" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-1">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Ativo</mat-label>
                  <input matInput readonly [value]="ativo ? 'Ativo' : 'Inativo'">
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Telefone</mat-label>
                  <input formControlName="telephone" matInput mask="(00) 0 0000-0000 || (00) 0000-0000" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Whatsapp</mat-label>
                  <input formControlName="whatsapp" matInput mask="(00) 0 0000-0000 || (00) 0000-0000" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>E-mail</mat-label>
                  <input formControlName="email" matInput required>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Pessoa de Contato</mat-label>
                  <input formControlName="pessoaContato" matInput required>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Contato</mat-label>
                  <input mask="(00) 0 0000-0000 || (00) 0000-0000" formControlName="contato" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>CEP</mat-label>
                  <input formControlName="cep" mask="00000-000" matInput (blur)="buscarDadosCep()" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Estado</mat-label>
                  <mat-select id="estado" name="estado" formControlName="estado" required
                    (selectionChange)="onEstadoChange($event.value)">
                    <mat-option [value]="estado" *ngFor="let estado of estados">{{ getSiglaEstado(estado) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Endereço</mat-label>
                  <input formControlName="address" matInput required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Quadra</mat-label>
                  <input formControlName="block" matInput required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Lote</mat-label>
                  <input formControlName="batch" matInput required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Complemento</mat-label>
                  <input formControlName="complement" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Bairro</mat-label>
                  <input id="bairro" name="bairro" formControlName="bairro" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" style="width: 100%;" *ngIf="cidades.length; else cidadeTexto">
                  <mat-label>Cidade</mat-label>
                  <mat-select id="cidade" name="cidade" formControlName="cidade">
                    <mat-option [value]="cidade" *ngFor="let cidade of cidades">{{ cidade }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-template #cidadeTexto>
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Cidade</mat-label>
                    <input id="cidade" name="cidade" formControlName="cidade" matInput>
                  </mat-form-field>
                </ng-template>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>TenantId</mat-label>
                  <input formControlName="tenantId" matInput required [readonly]="tenantIdBloqueado">
                  <button type="button" mat-icon-button matSuffix color="primary"
                          matTooltip="{{ tenantIdBloqueado ? 'Tenant já gerado e não pode ser alterado' : 'Gerar tenant' }}"
                          (click)="gerarTenantId()" [disabled]="tenantIdBloqueado">
                    <mat-icon>autorenew</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Segmentos</mat-label>
                  <mat-select formControlName="segmentos" multiple (selectionChange)="onSegmentosChange()">
                    <mat-option *ngFor="let s of segmentos" [value]="s.codigo || s.nome">
                      {{ s.nome }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Cliente pagador (Autoshopping)</mat-label>
                  <mat-select formControlName="clientePagadorId">
                    <mat-option [value]="null">Nenhum</mat-option>
                    <mat-option *ngFor="let c of clientesPagadoresFiltrados" [value]="c.id">
                      {{ c.razaoSocial || c.nomeFantasia }}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Se preenchido, este cliente será cobrado junto ao pagador.</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12 planos-segmento" *ngIf="planosSegmentoArray.length">
                <h4 class="seg-plano__titulo">Planos e cobrança por segmento</h4>
                <div class="row" formArrayName="planosSegmento">
                  <div class="col-12 col-md-6 col-lg-4"
                    *ngFor="let grupo of planosSegmentoArray.controls; let i = index" [formGroupName]="i">
                    <div class="seg-plano">
                      <span class="seg-plano__nome">{{ nomeSegmento(grupo.get('segmento')?.value) }}</span>
                      <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-label>Plano</mat-label>
                        <mat-select formControlName="planoId"
                          (selectionChange)="onPlanoSegmentoChange(grupo)">
                          <mat-option
                            *ngFor="let p of (planosPorSegmento[grupo.get('segmento')?.value] || [])"
                            [value]="p.id">
                            {{ p.nome }}
                          </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="!(planosPorSegmento[grupo.get('segmento')?.value] || []).length">
                          Nenhum plano ativo para este segmento.
                        </mat-hint>
                      </mat-form-field>
                      <div class="row">
                        <div class="col-6">
                          <mat-form-field appearance="fill" style="width: 100%;">
                            <mat-label>DT/Venc</mat-label>
                            <mat-select formControlName="diaVencimento">
                              <mat-option [value]="5">5</mat-option>
                              <mat-option [value]="10">10</mat-option>
                              <mat-option [value]="15">15</mat-option>
                              <mat-option [value]="20">20</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-6">
                          <mat-form-field appearance="fill" style="width: 100%;">
                            <mat-label>Carência</mat-label>
                            <input formControlName="carencia" type="number" matInput max="180">
                          </mat-form-field>
                        </div>
                      </div>
                      <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-label>Colaborador responsável pela venda</mat-label>
                        <mat-select formControlName="colaboradorId"
                          (selectionChange)="onColaboradorSegmentoChange(grupo)">
                          <mat-option [value]="null">Não informado</mat-option>
                          <mat-option *ngFor="let c of colaboradores" [value]="c.id">{{ c.nome }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="seg-plano__acoes">
                        <button type="button" mat-stroked-button color="primary"
                          class="seg-plano__btn-contrato"
                          [disabled]="!formulario.get('id')?.value || !grupo.get('planoId')?.value"
                          (click)="imprimirContrato(grupo)"
                          matTooltip="Imprimir contrato deste plano">
                          <mat-icon>print</mat-icon>
                          Imprimir contrato
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12" *ngIf="(formulario.get('segmentos')?.value || []).length === 0">
                <div class="seg-plano__aviso">
                  Selecione ao menos um segmento para definir o plano e a cobrança.
                </div>
              </div>

              <!-- Documentos -->
              <div class="col-12 doc-section">
                <div class="doc-section__header">
                  <h3><mat-icon>folder</mat-icon> Documentos</h3>
                  <button type="button" mat-stroked-button color="primary"
                          (click)="selecionarArquivo(fileInput)" [disabled]="!clienteId || enviandoDocumento">
                    <mat-icon>upload_file</mat-icon>
                    {{ enviandoDocumento ? 'Enviando...' : 'Anexar documentos' }}
                  </button>
                  <input #fileInput type="file" hidden multiple (change)="onArquivoSelecionado($event)">
                </div>

                <p class="doc-section__hint" *ngIf="!clienteId">
                  Salve o cliente para habilitar o anexo de documentos.
                </p>
                <p class="doc-section__hint" *ngIf="clienteId && documentos.length === 0">
                  Nenhum documento anexado. Qualquer formato até 25 MB. Selecione vários arquivos de uma vez.
                </p>
                <p class="doc-section__hint" *ngIf="clienteId && documentos.length > 0">
                  Qualquer formato até 25 MB. Selecione vários arquivos de uma vez.
                </p>

                <div class="doc-grid" *ngIf="documentos.length">
                  <div class="doc-card" *ngFor="let doc of documentos">
                    <div class="doc-card__icon">
                      <mat-icon>{{ iconeDocumento(doc) }}</mat-icon>
                    </div>
                    <div class="doc-card__info">
                      <span class="doc-card__name" [title]="doc.nome">{{ doc.nome }}</span>
                      <span class="doc-card__meta">{{ formatarTamanho(doc.tamanho) }} · {{ doc.dataUpload }}</span>
                    </div>
                    <div class="doc-card__acoes">
                      <button type="button" mat-icon-button color="primary" (click)="baixarDocumento(doc)" matTooltip="Baixar">
                        <mat-icon>download</mat-icon>
                      </button>
                      <button type="button" mat-icon-button color="warn" (click)="removerDocumento(doc)" matTooltip="Remover">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Observação</mat-label>
                  <textarea formControlName="observation" matInput></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="wow-form-acoes">
                <button type="button" mat-stroked-button (click)="voltarConsulta()">
                  <mat-icon>arrow_back</mat-icon> Voltar
                </button>
                <button mat-raised-button class="secondary-bg" type="button"
                  *ngIf="!importadoWowve && formulario.get('id')?.value != null"
                  (click)="criarCadastroWowve()">
                  <mat-icon>add</mat-icon> Criar Cadastro WOWve
                </button>
                <button mat-raised-button color="accent" type="button"
                  *ngIf="importadoWowve && formulario.get('id')?.value != null"
                  (click)="alterarPlanoWowve()">
                  <mat-icon>rotate_right</mat-icon> Alterar Plano WOWve
                </button>
                <button mat-raised-button type="button"
                  *ngIf="importadoWowve && formulario.get('id')?.value != null"
                  [color]="formulario.get('ativo')?.value ? 'warn' : undefined"
                  [class.success-button]="!formulario.get('ativo')?.value"
                  (click)="alterarStatusWowve()">
                  <mat-icon>{{ formulario.get('ativo')?.value ? 'block' : 'check_circle' }}</mat-icon>
                  {{ formulario.get('ativo')?.value ? 'Inativar Cadastro WOWve' : 'Ativar Cadastro WOWve' }}
                </button>
                <button [disabled]="!formulario.valid" mat-raised-button color="primary" type="button" (click)="submit()">
                  <mat-icon>save</mat-icon> Salvar
                </button>
            </div>
          </form>

          <div class="esp-top">
            <div *ngIf="formulario.controls.razaoSocial.errors && !formulario.controls.razaoSocial.pristine"
              class="alert alert-warning" role="alert">
              Campo nome deve conter entre 3 e 250 caracteres!
            </div>
          </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
